// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/semantic/semantic.less
// module id = 1222
// module chunks = 0